import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, CardHeader } from '@mui/material';
import { useEffect, useState } from 'react';
import { getImageUrl } from '../../../../data/aws/s3/UserBlobs';
export const ObjectHeader = ({ vob, urlOverride }) => {
    const [imageUrl, setImageUrl] = useState('');
    useEffect(() => {
        if (!urlOverride) {
            async function effectUrl() {
                const objectOrString = (await getImageUrl(vob, true)) ?? (await getImageUrl(vob, false));
                if (typeof objectOrString === 'string') {
                    const url = objectOrString;
                    setImageUrl(url);
                }
                else {
                    setImageUrl('');
                }
            }
            vob && effectUrl();
        }
    }, [vob?.sk, vob?.primaryS3Image?.key]);
    const src = urlOverride ?? imageUrl;
    const props = {
        title: vob?.name,
        avatar: (_jsx(Avatar, { "aria-label": "recipe", src: src, children: vob ? (vob.name ? vob.name.substring(0, 1).toUpperCase() : `${vob.type} ?`) : '??' })),
    };
    return _jsx(CardHeader, { ...props });
};
